module.exports = __webpack_public_path__ + "img/terroir-2-mobile.e93a692c.jpg";